import { RemoteSelect } from "@/components/fields/remote-select";

import { useEntitySelector } from "../../hooks";
import type { SandboxEntity } from "../../types/entities";
import type { EntitySelectorProps } from "../../types/entitySelector";

const EntitySelector = (props: EntitySelectorProps) => {
  const { value, entityType, onChange } = props;
  const { handleSearch, accessor } = useEntitySelector({ entityType });

  return (
    <RemoteSelect<SandboxEntity>
      value={value}
      label={`Select ${entityType.charAt(0).toUpperCase() + entityType.slice(1)}`}
      triggerType="change"
      onValueChanged={onChange}
      onSearch={handleSearch}
      accessorFn={accessor}
    />
  );
};

export default EntitySelector;
